import { makeStyles } from '@material-ui/core/styles';
import FailedTopUpBackground from 'assets/images/failed-top-up-bg.png';

export const useStyles = makeStyles(theme => ({
  modalContainer: {
    maxWidth: theme.spacing(320),
    padding: theme.spacing(54.5, 24, 30),
    borderRadius: 28,
    background: `${theme.palette.common.white} url(${FailedTopUpBackground}) no-repeat top center / contain`,
  },
  modalTitle: {
    fontSize: 26,
    fontWeight: 700,
    lineHeight: '39px',
    color: '#144167',
    padding: theme.spacing(17.5, 0, 20.5),
    whiteSpace: 'break-spaces',
    textAlign: 'center',
  },
  planeIconContainer: {
    borderRadius: '50%',
    boxShadow: '0px 9px 15px #00000015',
    backgroundColor: theme.palette.common.white,
    height: theme.spacing(63),
    width: theme.spacing(63),
  },
  backToDashboardBtn: {
    height: theme.spacing(28.5),
    color: '#000000',
    border: '1px solid #000000',

    '&:focus, &:hover': {
      color: '#000000',
      border: '1px solid #000000',
      background: 'unset'
    },
  },
  failed: {
    color: '#E02A2A',
    paddingLeft: theme.spacing(3),
  },
  modalError: {
    color: '#6E6E6E',
    fontSize: theme.spacing(9),
    lineHeight: theme.spacing(10.5) + 'px',
    paddingBottom: theme.spacing(20)
  },
}));
